
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Warning from "../common/Warning";
//import Dropzone from 'react-dropzone'
import { element } from "prop-types";
import IconClose from "../iconComponents/IconCloseNotification";
import { connect, useSelector } from "react-redux";
import SchedulePicker from "../common/SchedulePicker";
// import Toggle from "../common/Toggle";
import Addfiles from "../common/Addfiles";
import { alertPermissionsRequired } from "../../actions/messages";

// Client-side-only interim step for GitHub #650 (no upload type restriction existed at
// all before this) -- an allowlist of legitimate business document/image types, not a
// blocklist of dangerous ones. Easily bypassed by a direct API call; the real fix is
// the server-side check #650 still tracks.
const ALLOWED_ATTACHMENT_TYPES = "application/pdf,image/jpeg,image/png,image/gif,image/webp,image/tiff,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv";

export function ContractDetailsEdit(props) {

    const contract = useSelector( (state) => state.contract.contract );
    const projectDrops = useSelector(state => state.projects.projectDrops);
    const projectDrop = useSelector(state => state.projects.projectDrop);
    const invitation = useSelector( (state) => state.contract.invitation );
    const { handleDrop, selectedFiles, removedFiles, removeSelectedFile, removeUploadedFile, onChange, onBlur, onSubmit, details, cancelCreateContract, changes } = props;
    const {  id, attachments } = contract
    // if contract has no details saved and user "cancels" their edits, the draft is discarded and user is redirected to the project 
    const reviewMax = props.details.duration_payment ? parseInt(props.details.duration_payment, 10) - 1 : null;
    const paymentMin = props.details.duration_review ? parseInt(props.details.duration_review, 10) + 1 : null;
    const defaultReview = props.details.duration_review ? props.details.duration_review : (props.details.duration_payment && parseInt(props.details.duration_payment) < 15 ? parseInt(props.details.duration_payment) - 1 : 14);
    const defaultPayment = props.details.duration_payment ? props.details.duration_payment : (props.details.duration_review && parseInt(props.details.duration_review) > 27 ? parseInt(props.details.duration_review) + 1 : 28);


    return (
        <div className="gap-above-m form-wrapper" >
            { contract && 
            <form className="form" onSubmit={(e) => {
                e.preventDefault();
                props.onSubmit(e);
            }}>
                {/* <form onSubmit={this.props.onSubmit}> */}
                <div >
                    <div className="inputs-wrapper">
                        <div className="input-basic addspace">
                            <input
                                name="contract_name"
                                id="contract_name"
                                defaultValue={ contract.contract_name ? contract.contract_name : ""}
                                maxLength="75"
                                onChange={(e) => onChange(e)}
                                // onChange={this.props.onChange}
                                title="75 characters max"
                                required
                            />
                            <label htmlFor="contract_name">Contract Name <span>*</span></label>
                        </div>
                        <div className="input-basic addspace">
                            <input
                                name="contract_number"
                                type="text"
                                id="contract_number"	
                                defaultValue={ contract.contract_number ? contract.contract_number : ""}
                                onChange={(e) => onChange(e)}
                                // onChange={this.props.onChange}  
                            />
                            <label htmlFor="contract_number">Contract Number</label>
                        </div>
                        <div className="input-basic textarea addspace">	
                            <label className="textarea" htmlFor="contract_description">Description</label>			
                            <textarea 
                                type="text" 
                                name="contract_description" 
                                id="contract_description" 
                                rows="3" 
                                defaultValue={contract.contract_description ? contract.contract_description : ""}
                                onChange={(e) => onChange(e)}
                            />
                        </div>
                        <div className="input-basic addspace">
                            <input
                                type="number"
                                name="contract_value"
                                id="contract_value"
                                placeholder="0.00"	
                                onBlur={(e) => onBlur(e)}
                                step=".01"
                                min="0"
                                defaultValue={contract.contract_value ? contract.contract_value : ""}
                                // defaultValue={ contract.contract_value ? contract.contract_value : ""}
                                onChange={(e) => onChange(e)}
                                // onChange={this.props.onChange}
                                />
                            <label htmlFor="contract_value">Value</label>
                        </div>
                    </div>
                    <div className="gap-above-m">
                        <h3 className="content2 heavy-grey gap-below-s">Invoice Schedule</h3>
                        <div className="schedule-picker content2">
                            <SchedulePicker 
                                label="Review Deadline" 
                                default={defaultReview}  
                                edit={onChange} 
                                id="duration_review" 
                                selected={props.details.duration_review} 
                                max={reviewMax}
                            />
                            <SchedulePicker 
                                label="Payment Deadline" 
                                default={defaultPayment} 
                                edit={onChange} 
                                id="duration_payment" 
                                selected={props.details.duration_payment} 
                                min={paymentMin}
                            />
                        </div>
                    </div>
                    <div className="gap-above-m gap-below-m">
                        <h3 className="content2 heavy-grey ">Documents</h3>
                        <Addfiles 
                            uploadTitle="+ Add Contract Documents"
                            attachments={contract.attachments} 
                            selectedFiles={selectedFiles}
                            handleDrop={handleDrop}
                            removeSelectedFile={removeSelectedFile}
                            removeUploadedFile={removeUploadedFile}
                            removedFiles={removedFiles}
                            maxSize={10485760}
                            maxFiles={0}
                            multiple={true}
                            accept={ALLOWED_ATTACHMENT_TYPES}
                        />
                    </div>   
                    {(!contract.invitations || contract.invitations?.length < 1) &&
                    <div className="flex-row" style={{flex: 1, justifyContent: "flex-end", alignItems: "flex-end", zIndex: "100"}} >    
                        <button onClick={() => props.cancelEditContract()} disabled={props.isSubmitting} className="btn min-width sec gap-right-s flex1">Cancel</button>
                        <button id="contract_save_details" className="btn min-width pri flex1" type="submit" disabled={props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Save Details"}</button>
                    </div>
                    }
                </div>
            </form>  
            }  
        </div>
    )
}

const mapState = (state) => ({
    contract: state.contract.contract
});

export default connect(mapState, {alertPermissionsRequired})(ContractDetailsEdit);